module.exports = __webpack_public_path__ + "img/ico-trash-red.08417fa9.svg";